<template>
	<app background="#fff">
		<project-bidding ref="projectBidding"></project-bidding>
		
		<button-list-m slot="foot">
			<c-button @click="submit">确认并提交</c-button>
		</button-list-m>
	</app>
</template>

<script>
	import projectBidding from './project_bidding_form.vue'
	
	export default {
		components: {
			projectBidding
		},
		
		props: {
			id: String
		},
		
		mounted() {
			this.$refs.projectBidding.edit(this.id);
		},
		
		methods: {
			submit() {
				this.$refs.projectBidding.submit().then(() => {
					this.$message({
						text: '提交成功',
						resolve: () => {
							this.navigateBack();
						}
					});
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
</style>